export function operacaoConsultaImpedimentosInRequest(params = {}) {
  return {
    type: '@operacaoconsultaimpedimentos/CONSULTAIMPEDIMENTOS_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoConsultaImpedimentos(imab_codigo) {
  return {
    type: '@operacaoconsultaimpedimentos/FIND_CONSULTAIMPEDIMENTOS',
    payload: { imab_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoconsultaimpedimentos/FAILED_REQUEST',
  };
}

export function deleteOperacaoConsultaImpedimentos(imab_codigo, params) {
  return {
    type: '@operacaoconsultaimpedimentos/DELETE_CONSULTAIMPEDIMENTOS',
    payload: { imab_codigo, params },
  };
}

export function updateOperacaoConsultaImpedimentos(operacaoconsultaimpedimentos, params) {
  return {
    type: '@operacaoconsultaimpedimentos/UPDATE_CONSULTAIMPEDIMENTOS',
    payload: { operacaoconsultaimpedimentos, params },
  };
}

export function storeOperacaoConsultaImpedimentos(operacaoconsultaimpedimentos, params) {
  return {
    type: '@operacaoconsultaimpedimentos/STORE_CONSULTAIMPEDIMENTOS',
    payload: { operacaoconsultaimpedimentos, params },
  };
}

export function successInRequest(
  operacaoconsultaimpedimentos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoconsultaimpedimentos/SUCCESS_IN_REQUEST',
    payload: { operacaoconsultaimpedimentos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaoconsultaimpedimentos) {
  return {
    type: '@operacaoconsultaimpedimentos/SUCCESS_REQUEST',
    payload: { operacaoconsultaimpedimentos },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoconsultaimpedimentos/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoconsultaimpedimentos/RECORD_FILTERING',
    payload: { params },
  };
}
